import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StringXSmall } from '@components/Typography/Typography';
import { CashImage } from '@components/ui/CashImage/CashImage';
import cn from 'classnames';

import { convertRemToPixels } from '@/common/lib/convertRemtoPx';
import { Picture } from '@/components/ui/Picture/Picture';
import { useAppSelector } from '@/redux/store';

import { AccountLevelRowData } from './AccountLevelRowData';

import css from './styles.module.scss';

import starPng from '/img/icons/star.png';
import starWebp from '/img/icons/star.webp';
import tgemPng from '/img/tgem.png';
import tgemWebp from '/img/tgem.webp';

interface ReferralIncomeTableProps {
  level: '1' | '2' | '3';
}

const ReferralIncomeTable: FC<ReferralIncomeTableProps> = ({ level }) => {
  const { t } = useTranslation();
  const referralRewards = useAppSelector(
    (state) => state.user.referralEarnings?.referralRewards,
  );

  return (
    <div className={css.referralIncomeTable}>
      <div className={cn(css.tableHead, css.columnTemplate)}>
        <StringXSmall
          weight="bold"
          className="max-w-[7.0625rem] !text-white/60"
        >
          {t('Friends account Level')}
        </StringXSmall>
        <StringXSmall weight="bold" className="justify-self-end">
          {t('Rewards')}
        </StringXSmall>
        <StringXSmall
          weight="bold"
          className="justify-self-end max-w-[3.4375rem] !text-gold"
        >
          {t('With VIP')}
        </StringXSmall>
      </div>

      <div className="w-full">
        <div className={cn('py-2', css.columnTemplate)}>
          <picture className="w-8 h-8">
            <source srcSet={starWebp} type="image/webp" />
            <img src={starPng} alt="cash" />
          </picture>
          {Array.from({ length: 2 }).map((_, index) => (
            <div className="w-full flex gap-4 justify-end" key={index}>
              <CashImage size={convertRemToPixels(2)} />
              <Picture
                className="w-8 h-8"
                img={tgemPng}
                webp={tgemWebp}
                alt="tgem"
              />
            </div>
          ))}
        </div>
        <div className="w-full overflow-y-auto h-[40vh] hidden-scrollbar">
          {referralRewards &&
            referralRewards[level].map((props) => (
              <AccountLevelRowData {...props} />
            ))}
        </div>
      </div>
    </div>
  );
};

export { ReferralIncomeTable };
